<fc-advertiser-disclosure *ngIf="product && showHeading"></fc-advertiser-disclosure>
<fc-advertised-product *ngIf="product" [product]="product" [pageDetails]="pageDetails" [showHeading]="showHeading" [paging]="paging"></fc-advertised-product>
<fc-product-placeholder *ngIf="!product" [pageDetails]="pageDetails"></fc-product-placeholder>
